import { CollectionColumnId } from 'view/routes/ColumnNames'
import { LiveGridColumnId } from 'view/routes/requests/LiveNegotiationsGrid/LiveGridColumnNames'

export const DEFAULT_INITIATED_SUMMARY_MAP_KEY = `${CollectionColumnId.COLLECTION_NAME}-${LiveGridColumnId.COUNTERPARTY_NAME}`
